import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import * as Cookies from "es-cookie";
import './_navbars.scss';

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import MobileAsideNavbar from "./MobileAsideNavbar";
import WebAsideNavbar from "./WebAsideNavbar";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

const FETCH_ISSTUDENTUSERVALID = gql` 
query($student_user_exam_id: Int!) {
    isStudentUserValid(student_user_exam_id: $student_user_exam_id){
        estatus
        current_plan_id
        expiry_date
        app_version
        user_access_restictions
     }
}

`;



class AsideNavbar extends Component {
    render() {
        // console.log("isBrowserisMobile", isBrowser,
        //     isMobile);
        if (Cookies.get("studenttoken") == undefined) {
            if (this.props && this.props.history) this.props.history.push("/student/login");
            return null;
        }

        // Safely read any cached student-valid info from localStorage
        let isStudentUserValid1 = null;
        try {
            const raw = localStorage.getItem("isStudentUserValid");
            isStudentUserValid1 = raw ? JSON.parse(raw) : null;
        } catch (e) {
            isStudentUserValid1 = null;
        }

        if (!isStudentUserValid1) {
            if (this.props && this.props.history) this.props.history.push("/student/login");
            return null;
        }

        let isuserValid = {};
        try {
            isuserValid = isStudentUserValid1.user_access_restictions
                ? JSON.parse(isStudentUserValid1.user_access_restictions)
                : {};
        } catch (e) {
            isuserValid = {};
        }

        const isStudentUserValid = this.props.isStudentUserValid || {};
        const loading5 = isStudentUserValid?.loading;
        const error5 = isStudentUserValid?.error;
        if (loading5) {
            if (isBrowser) {
                return (
                    <div id="sidebar" className="sidebar-menu d-none d-xl-block d-lg-block">
                        <WebAsideNavbar onClick={this.props.onClick} isuserValid={isuserValid} />
                    </div>
                )
            }
            if (isMobile) {
                return (
                    <div id="sidebar" className="sidebar-menu d-block d-xl-none d-lg-none">
                        <MobileAsideNavbar onClick={this.props.onClick} isuserValid={isuserValid} />
                    </div>
                )
            }

        }
        if (error5) {
            return null;
        }

        if (isStudentUserValid?.isStudentUserValid) {
            if (isStudentUserValid.isStudentUserValid.estatus == 0) {
                Cookies.remove("token");
                Cookies.remove("username");
                Cookies.remove("refreshtoken");
                Cookies.remove("email");
                Cookies.remove("id");
                Cookies.remove("institutionid");
                Cookies.remove("userlevel");
                Cookies.remove("name");
                if (this.props && this.props.history) this.props.history.push("/student/login");
                return null;
            }
        }

        // Merge/override isuserValid with server-provided restrictions if available
        try {
            const serverRestrictions = isStudentUserValid?.isStudentUserValid?.user_access_restictions;
            if (serverRestrictions) {
                isuserValid = JSON.parse(serverRestrictions);
            }
        } catch (e) {
            // keep previous isuserValid
        }

        if (isBrowser) {
            return (
                <div id="sidebar" className="sidebar-menu d-none d-xl-block d-lg-block">
                    <WebAsideNavbar onClick={this.props.onClick} isuserValid={isuserValid} />
                </div>
            )
        }
        if (isMobile) {
            return (
                <div id="sidebar" className="sidebar-menu d-block d-xl-none d-lg-none">
                    <MobileAsideNavbar onClick={this.props.onClick} isuserValid={isuserValid} />
                </div>
            )
        }

    }
}



export default withRouter(
    compose(
        graphql(FETCH_ISSTUDENTUSERVALID,
            {
                options: props => ({
                    variables: {
                        student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                    }
                    ,
                    // Shared cache entry; revalidated on navigation by utils/sessionValidity.
                    fetchPolicy: "cache-first"
                }), name: "isStudentUserValid"
            })
    )(AsideNavbar)
);